import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import LeftIcon from '../../../new-components/svg-icons/LeftIcon';
import RightIcon from '../../../new-components/svg-icons/RightIcon';
import { logEvent } from '../../../new-lib/analytics';

type BacklinksProps = {
  compoundDetails: {
    name: string;
    slug: string;
  };
  availablePropertyTypes: PropertyType[];
};

type PropertyType = {
  name: string;
  properties: [];
  total: number;
};

const Backlinks = ({
  compoundDetails,
  availablePropertyTypes
}: BacklinksProps) => {
  const { t } = useTranslation('entity');
  const { locale } = useRouter();

  return (
    <BacklinksContainer>
      <h2 className="headline-3">
        {t('explore_more_properties_in') + ' '}
        {compoundDetails.name}
      </h2>
      <ul className="links">
        {availablePropertyTypes.map((type, idx) => {
          return (
            <li className="text-1" key={idx}>
              <Link
                href={`/compound/${encodeURIComponent(
                  compoundDetails.slug
                )}/${encodeURIComponent(type.name)}`}
                prefetch={false}
                onClick={() =>
                  logEvent.click(
                    'cmpnd_backlinks_click',
                    'CheckMoreInCompoundSection',
                    'compound'
                  )
                }
              >
                <Image
                  width={19}
                  height={19}
                  src={'/assets/icons/common/backlinks-icon.svg'}
                  alt="backlinks-icon"
                  onError={({ target }: any) => {
                    target.src = '/assets/images/common/broken.webp';
                  }}
                />
                <h3>
                  {' '}
                  {`${type.total} ${type.name} ${t('for_sale_in')} ${
                    compoundDetails.name
                  }`}
                </h3>
                {locale == 'en' ? (
                  <RightIcon stroke="#898989" />
                ) : (
                  <LeftIcon stroke="#898989" />
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </BacklinksContainer>
  );
};

const BacklinksContainer = styled.div`
  h2.headline-3 {
    margin-bottom: 8px;
    display: block;
  }

  li {
    padding: 4px 0;
    a {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-bottom: 5px;

      h3 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0;
        font-size: 1em;
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    li h2 {
      font-size: ${props => props.theme.font.sizes.s}!important;
      margin-bottom: 5px;
    }
  }
`;
export default Backlinks;
